// deps
import React, { ReactElement, useContext, memo } from "react";
import invariant from "tiny-invariant";

// internal-deps
import { NetbankingMoreBanks, INetBankingPaymentGroup, PaymentProgressLoader } from "@swiggy-private/payment-ui";

// components
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import { PaymentActionProvider } from "@payment-client/components/show-payments/components/payment-action-provider";

// interfaces
import { RouteProps } from "@payment-client/interfaces/Router";

// contexts
import { PlaceOrderContext } from "@payment-client/contexts/PlaceOrderContext";
import { NetbankingMoreBanksContext } from "@payment-client/contexts/NetbankingMoreBanksContext";

type NetBankingMoreBanksProps = RouteProps<{ paymentGroup: INetBankingPaymentGroup["paymentData"] }>;

export const NetBankingMoreBanks = memo(function NetBankingMoreBanks({
    data,
}: NetBankingMoreBanksProps): ReactElement | null {
    const { processingOrder, placeOrderInProgress } = useContext(PlaceOrderContext);
    const { bankList } = useContext(NetbankingMoreBanksContext);
    invariant(data?.paymentGroup, "Missing payment data");

    const header = <CommonHeaderContent title={"Select Bank"} />;
    const content = (
        <>
            {(placeOrderInProgress || processingOrder) && <PaymentProgressLoader />}
            <PaymentActionProvider>
                {({ onPay }): ReactElement => (
                    <NetbankingMoreBanks
                        paymentInProgress={processingOrder || placeOrderInProgress}
                        paymentGroupData={data.paymentGroup}
                        netBankingList={bankList}
                        onPay={onPay}
                    />
                )}
            </PaymentActionProvider>
        </>
    );

    return <CommonUIWrapper header={header} content={content} />;
});
